import SvgArrow from '@img/icons/arrow-right.svg';
import * as React from 'react';
import S from '../Button/Button.styles';
const LinkButton = ({ buttonType, children, fillDirection = 'right', icon, iconOnly, iconPosition = 'right', ...otherProps }) => {
    return (React.createElement(S.Container, { as: "a", "data-fill": fillDirection, "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-type": buttonType, ...otherProps },
        React.createElement(S.Text, null, children),
        React.createElement(S.IconWrapper, null, icon ?? React.createElement(SvgArrow, null))));
};
export default LinkButton;
